import React from 'react';
import { useStore } from '@hooks';
import { observer } from 'mobx-react';
import InfoContentWrap from '../InfoContentWrap';
import AdditionalSetup from './components/AdditionalSetup';

const IntegrationsInfo = observer(() => {
    const store = useStore();
    const { isManual } = store.accountsStore;

    return <InfoContentWrap>{isManual && <AdditionalSetup />}</InfoContentWrap>;
});

export default IntegrationsInfo;
